var AnalysisTaskState = /* @__PURE__ */ ((AnalysisTaskState2) => {
  AnalysisTaskState2["Pending"] = "Pending";
  AnalysisTaskState2["Ready"] = "Ready";
  AnalysisTaskState2["Submitting"] = "Submitting";
  AnalysisTaskState2["Submitted"] = "Submitted";
  AnalysisTaskState2["SubmittedToCluster"] = "SubmittedToCluster";
  AnalysisTaskState2["CompletedFailure"] = "CompletedFailure";
  AnalysisTaskState2["CompletedSuccess"] = "CompletedSuccess";
  AnalysisTaskState2["Deprecated"] = "Deprecated";
  AnalysisTaskState2["Cancelled"] = "Cancelled";
  AnalysisTaskState2["WaitingForData"] = "WaitingForData";
  AnalysisTaskState2["WaitingForComputeResource"] = "WaitingForComputeResource";
  AnalysisTaskState2["CancelledByVC"] = "CancelledByVC";
  AnalysisTaskState2["CancelledByUser"] = "CancelledByUser";
  AnalysisTaskState2["CancelledByExP"] = "CancelledByExP";
  return AnalysisTaskState2;
})(AnalysisTaskState || {});
const CancelledAnalysisTaskStates = [
  "Cancelled",
  "CancelledByExP",
  "CancelledByUser",
  "CancelledByVC"
  /* CancelledByVC */
];
var JobProfileType = /* @__PURE__ */ ((JobProfileType2) => {
  JobProfileType2["Regular"] = "Regular";
  JobProfileType2["Merged"] = "Merged";
  return JobProfileType2;
})(JobProfileType || {});
export {
  AnalysisTaskState,
  CancelledAnalysisTaskStates,
  JobProfileType
};
//# sourceMappingURL=Task.js.map
